import NavHeader from "../shared/Nav-Header";

const NotificationPage = () => {
  return (
    <div>
        <NavHeader />
        <h1>Notifications</h1>
        
        </div>
  );
}
export default NotificationPage;